import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  FiGrid,
  FiUserPlus,
  FiUsers,
  FiFolder,
  FiPackage,
  FiShoppingCart,
  FiShoppingBag,
  FiFileText,
  FiMessageCircle,
  FiTag,
  FiBarChart2,
  FiSettings,
  FiHelpCircle,
  FiLogOut,
  FiMenu,
  FiX,
  FiChevronsLeft,
  FiChevronsRight,
  FiTruck,
  FiCreditCard,
  FiSliders,
} from 'react-icons/fi';
import { BsShop } from 'react-icons/bs';
import Swal from 'sweetalert2';
import '../../../assets/css/components/admin/sidebar/AdminSidebar.css';

const AdminSidebar = ({ isCollapsed, setIsCollapsed, isMobileOpen, setIsMobileOpen, isMobile }) => {
  const navigate = useNavigate();

  const closeSidebarOverlay = () => {
    setIsMobileOpen(false);
  };

  const closeSidebarOnNavClick = () => {
    if (isMobile) setIsMobileOpen(false);
  };

  const logoutAdmin = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Logout',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#097d43',
      cancelButtonColor: '#dc3545',
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("adminEmail");
        localStorage.removeItem("adminPassword");
        Swal.fire({
          title: 'Logged Out!',
          text: 'You have been logged out successfully.',
          icon: 'success',
          confirmButtonColor: '#097d43',
          timer: 2000
        }).then(() => navigate('/admin/login'));
      }
    });
  };
  const navItems = [
    { icon: FiGrid,          label: 'Dashboard',          path: '/admin/dashboard'      },

    // ---- Users ----
    { icon: FiUserPlus,      label: 'Sub-admins',         path: '/admin/sub-admins'     },
    { icon: BsShop,          label: 'Sellers',            path: '/admin/sellers'        },
    { icon: FiUsers,         label: 'Customers',          path: '/admin/customers'      },
    { icon: FiTruck,         label: 'Delivery Men',       path: '/admin/delivery'       },

    // ---- Operational flow ----
    { icon: FiFolder,        label: 'Categories',         path: '/admin/categories'     },
    { icon: FiPackage,       label: 'Products',           path: '/admin/products'       },
    { icon: FiSliders,       label: 'Vehicles ',      path: '/admin/vehicles'  },
    { icon: FiShoppingCart,  label: 'Orders',             path: '/admin/orders'         },
    { icon: FiCreditCard,    label: 'Topup Management',   path: '/admin/topup'          },
    { icon: FiShoppingBag,   label: 'Payout Requests',    path: '/admin/payout-requests'},

    // ---- Content ----
    { icon: FiFileText,      label: 'Blogs',              path: '/admin/blogs'          },
    { icon: FiMessageCircle, label: 'FAQs Management',    path: '/admin/faqs'           },
    // { icon: FiTag,           label: 'Marquee Management', path: '/admin/sales-marquee'  },
    // { icon: FiBarChart2,     label: 'Analytics',          path: '/admin/analytics'      },

    // ---- Support / System ----
    { icon: FiHelpCircle,    label: 'Help & Support',     path: '/admin/help-support'   },
    { icon: FiSettings,      label: 'Settings',           path: '/admin/settings'       },
  ];

  // React controls classes — zero media queries
  const sidebarClass = [
    'adm-sidebar',
    isMobile ? 'adm-sidebar--mobile' : '',
    isMobile && isMobileOpen ? 'adm-sidebar--mobile-open' : '',
    !isMobile && isCollapsed ? 'adm-sidebar--collapsed' : '',
  ].filter(Boolean).join(' ');

  const showLabel = isMobile ? true : !isCollapsed;

  return (
    <>
      {/* Overlay - only when mobile & open */}
      {isMobile && isMobileOpen && (
        <div
          className="adm-sidebar-overlay"
          onClick={() => closeSidebarOverlay()}
        />
      )}

      <div className={sidebarClass}>

        {/* Logo */}
        <div className={`adm-sidebar__logo ${!showLabel ? 'adm-sidebar__logo--centered' : ''}`}>
          <div className="adm-sidebar__logo-icon">K</div>
          {showLabel && (
            <div className="adm-sidebar__logo-text">
              <h4>Kisaan Mart</h4>
              <p>Admin Panel</p>
            </div>
          )}
        </div>

        {/* Navigation */}
        <nav className="adm-sidebar__nav">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <div key={item.path} className="adm-sidebar__nav-item">
                <NavLink
                  to={item.path}
                  className="adm-sidebar__nav-link"
                  onClick={() => closeSidebarOnNavClick()}
                  title={!showLabel ? item.label : ''}
                >
                  <span className="adm-sidebar__nav-icon"><Icon /></span>
                  {showLabel && (
                    <span className="adm-sidebar__nav-label">{item.label}</span>
                  )}
                </NavLink>
              </div>
            );
          })}
        </nav>

        {/* Logout */}
        <button
          className={`adm-sidebar__logout ${!showLabel ? 'adm-sidebar__logout--icon-only' : ''}`}
          onClick={() => logoutAdmin()}
        >
          <span className="adm-sidebar__nav-icon"><FiLogOut /></span>
          {showLabel && <span>Logout</span>}
        </button>

      </div>
    </>
  );
};

export default AdminSidebar;
